import { FC, ReactNode, useEffect, useState } from "react";
import { TeamContext } from "../../types/common";
import { TournamentSelector } from "../../components/TournamentSelector";
import { StatsTournamentSelectorsDto, StatsType, TournamentStageType } from "../../types/stats";
import { getSelectors, getTournamentStages } from "../../api/transport/statsTransport";
import { ConfigProvider } from "antd";
import { SummaryTableMiniWidget } from "../../widgets/stats/tournament-table/SummaryTableMiniWidget";
import { StatsSelector } from "./StatsSelector";

interface StatsPageProps {
    teamContext?: TeamContext;
    pageType?: StatsType;
    children?: ReactNode;
    onTournamentChange?: (tournamentUuid: string, seasonUuid: string, legacyTournament?: number, legacySeason?: number) => void;
}

export const StatsPage: FC<StatsPageProps> = ({
    teamContext,
    pageType,
    onTournamentChange,
    children,
}) => {
    const [selectorOptions, setSelectorOptions] = useState<StatsTournamentSelectorsDto>();
    const [legacyTournamentId, setLegacyTournamentId] = useState<number>();
    const [menuItems, setMenuItems] = useState<StatsType[]>([]);

    useEffect(() => {
        getSelectors(teamContext).then((data) => {
            setSelectorOptions(data);
        }).catch(() => {
            setSelectorOptions(undefined);
        });
    }, []);

    if (!selectorOptions) {
        return null;
    }

    const onTournamentSelect = async (tournamentUuid: string, seasonUuid: string, legacyTournament?: number, legacySeason?: number) => {
        if (onTournamentChange) {
            onTournamentChange(tournamentUuid, seasonUuid, legacyTournament, legacySeason);
            setLegacyTournamentId(legacyTournament);
        }
        if (!tournamentUuid) {
            return;
        }

        const menu = [StatsType.CALENDAR];

        const stages = await getTournamentStages(tournamentUuid);

        if (stages?.filter(s => s.type === TournamentStageType.REGULAR)?.length) {
            menu.push(StatsType.TOURNAMENT_TABLE);
        }
        menu.push(StatsType.PLAYER);

        setMenuItems(menu);
    }

    let sider = null;
    if (teamContext === TeamContext.ACADEMY && legacyTournamentId && pageType === StatsType.TOURNAMENT_TABLE) {
        sider = (
            <SummaryTableMiniWidget
                //summaryTableId={config.summaryTableId}
                tournamentLegacyId={legacyTournamentId}
            />
        );
    }

    return (
        <div className="pb-4 pt-4 sm:pt-0">
            <ConfigProvider
                theme={{
                    components: {
                        Menu: {
                            /* here is your component tokens */
                            itemBorderRadius: 8,
                            itemSelectedBg: '#133D5E',
                            itemSelectedColor: '#fff',
                            fontSize: 16,
                            itemHeight: 46,
                            horizontalItemBorderRadius: 8,
                            horizontalItemSelectedBg: '#133D5E',
                            horizontalItemSelectedColor: '#fff',
                            horizontalItemHoverBg: 'rgb(232, 244, 255)',
                            activeBarBorderWidth: 0,
                            activeBarHeight: 0,
                        },
                    },
                }}
            >
                <div className="flex flex-col items-end sm:flex-row sm:items-end justify-between max-w-full">
                    <div className="mx-auto sm:mx-0">
                        <TournamentSelector
                            selectorOptions={selectorOptions}
                            onSelect={onTournamentSelect}
                        />
                    </div>
                    {/*<div>
                        <StatsSelector2
                            items={menuItems}
                            selected={pageType}
                        />
                    </div>*/}
                    <div className="py-2 px-3 sm:p-0 min-w-1/2 fixed bottom-24 sm:bottom-12 z-10 left-0 right-0 mx-auto">
                        <StatsSelector
                            items={menuItems}
                            selected={pageType}
                            teamContext={teamContext}
                        />
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row items-start max-w-full gap-4 mt-4">
                    <div className="w-full">
                        {children}
                    </div>
                    {sider}
                </div>
            </ConfigProvider>
        </div>
    )
}